// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D3d2Zyj","header":"_5D3QXkYd","main":"_5D1hx1a2","description":"_5Du_uhj9","team-members":"_5D3JlIhD","title":"_5D3hLrOi","search":"_5D1wnM8M"};